import {HoldState, Market, RecommendSource, RecommendState} from '@/model/const';

export default {
    getMarket: (market?: string) => {
        if (market === Market.SZ) {
            return '深圳(SZ)';
        } else if (market === Market.SH) {
            return '上海(SH)';
        }

        return '';
    },

    getRecommendState: (state?: string) => {
        if (state === RecommendState.BUY) {
            return '买入';
        } else if (state === RecommendState.SELL) {
            return '卖出';
        }
        return '';
    },

    getRecommendSource: (state?: string) => {
        if (state === RecommendSource.MIN7) {
            return '7分钟';
        } else if (state === RecommendSource.SELF) {
            return '自选';
        }
        return '';
    },

    getHoldState: (state?: string) => {
        if (state === HoldState.BOUGHT) {
            return '持有';
        } else if (state === HoldState.SOLD) {
            return '清仓';
        }
        return '';
    },
};
